"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderTrack = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SliderMixin = require("../../mixins/components/SliderMixin");
/**
 * @since 6.12.0
 */
var SliderTrack = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "SliderTrack",
  componentId: "c11n-8-107-0__sc-jhfpap-0"
})(["", ""], _SliderMixin.SliderTrackMixin);
exports.SliderTrack = SliderTrack;
SliderTrack.displayName = 'SliderTrack';

/** @component */